const columns = [
    {
        title: 'Title',
        dataIndex: 'title',
    },
    {
        title: 'Description',
        dataIndex: 'description',
    },
    {
        title: 'Type',
        dataIndex: 'tutorialType',
        sortet: true
    },
    {
        title: 'Created Date',
        dataIndex: 'createdDate',
        sortet: true
    },
    {
        title: 'Status',
        dataIndex: 'status',
    },
    {
        title: 'Actions',
        dataIndex: 'actions',
    },
];

export default columns;